import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CreditCardService } from '../../../shared/cards/credit-card.service';
import { StatusCreditCard } from '../../../shared/cards/credit-card-status.enum';
import { DomSanitizer } from '@angular/platform-browser';
import { Auth } from '../../../autentication/Auth';

@Component({
	selector: 'app-dashboard-banner-credit-card',
	templateUrl: './banner-credit-card.component.html',
	styleUrls: ['./banner-credit-card.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class DashboardBannerCreditCardComponent implements OnInit {
	public img: any;

	constructor(
		private router: Router,
		private creditCardService: CreditCardService,
		private sanitizer: DomSanitizer) {}

	ngOnInit(): void {
		this.getImgBannerCreditCard();
	}

	showCreditBanner(): boolean {

		if (Auth.getInstance().getUser().rule === 'CONSULTAR') {
			return false;
		}

		const status = this.creditCardService.status;

		switch (status) {
			case StatusCreditCard.NAOPROCESSADO:
				return false;
			case StatusCreditCard.APROVADO:
				return true;
			case StatusCreditCard.FINALIZADO:
				return false;
			case StatusCreditCard.RECUSADO:
				return false;
			default:
				return false;
		}
	}

	getImgBannerCreditCard() {
		this.creditCardService.getImgCreditCart().subscribe(data => {
			if (data.Sucesso && data.Existe) {
				this.creditCardService.creditCardImg = data.Retorno.Imagem;
				this.img = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.creditCardService.creditCardImg);
			}
		});
	}

	goToActivation = () => this.router.navigate(['cartoes-ativacao/credito/ativacao']);

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/dashboard/banner-credit-card/banner-credit-card.component.ts